import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/new/folder.png'


const _withScopeId = n => (_pushScopeId("data-v-9d83efc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "databaselist" }
const _hoisted_2 = { class: "levelnav" }
const _hoisted_3 = {
  key: 0,
  class: "levelnav_wrap"
}
const _hoisted_4 = {
  key: 1,
  style: {"margin-top":"100px"}
}
const _hoisted_5 = { class: "folder" }
const _hoisted_6 = {
  key: 0,
  class: "folder_wrap"
}
const _hoisted_7 = { class: "folder_item" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "folder_item_left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "folder_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_11 = { class: "folder_name" }
const _hoisted_12 = { class: "folder_item_right" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_14 = ["onClick"]

import { onMounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import NavList from './components/navlist/index.vue'
import { dataInit } from '@/hooks/useDatabaseMenuFiltering'
import { TLastdicType, TMenuType } from '@/module/database';

type TState = {
    menuData: Array<TMenuType>
    subItem: Array<TMenuType>
    tabIndex: number | string
    subIndex: number | string
    fatherId: number
    listData: Array<TLastdicType>
    taggerIndex: number | string
    taggerHeight: number
    liColHeight: number
    loading: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const { getFilterMenus, getDicList } = dataInit()

const state = reactive<TState>({
    menuData: [],
    subItem: [],
    tabIndex: '',
    subIndex: '',
    fatherId: 0,
    listData: [],
    taggerIndex: '',
    taggerHeight: 0,
    liColHeight: 0,
    loading: false
})

let licol = ref()


onMounted(async () => {
    if (route.query.Id) {
        let Id = route.query.Id as string
        state.fatherId = Number(Id)
        getFilterMenusData(state.fatherId, 0)
        getDicListData(state.fatherId)
    }

})
//获取二级三级导航
const getFilterMenusData = async (fatherId: number, type: number) => {
    if (type === 0) {
        state.menuData = await getFilterMenus({ ParentId: fatherId })
    } else {
        state.subItem = await getFilterMenus({ ParentId: fatherId })
    }
}

//获取文件夹
const getDicListData = async (fatherId: number) => {
    try {
        state.loading = true
        state.listData = await getDicList(fatherId)
    } catch (error) {

    } finally {
        state.loading = false
    }

}

//二级导航事件
const onTabsSwitch = (Id: number, index: number) => {
    state.subIndex = ''
    state.tabIndex = index
    getFilterMenusData(Id, 1)
    getDicListData(Id)
}
//三级导航事件
const onSubSwitch = (Id: number, index: number) => {
    state.subIndex = index
    getDicListData(Id)

}
const onRouterDetail = (Id: number) => {
    router.push({ path: 'databaseDetail', query: { Id } })
}

const onTagger = (row: TLastdicType, index: number) => {
    let liCol = licol.value[index]
    liCol.style.height = 0
    if (state.taggerIndex !== index) {
        state.taggerIndex = index
        liCol.style.height = "auto";
        let f = document.body.offsetHeight;
        liCol.style.height = (row.ContentList.length * 50) + 'px'
    } else {
        state.taggerIndex = ''
        liCol.style.height = 0
    }
}


return (_ctx: any,_cache: any) => {
  const _component_ArrowUp = _resolveComponent("ArrowUp")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (state.menuData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(NavList, {
              menuData: state.menuData,
              subItem: state.subItem,
              tabIndex: state.tabIndex,
              subIndex: state.subIndex,
              onOnTabsSwitch: onTabsSwitch,
              onOnSubSwitch: onSubSwitch
            }, null, 8, ["menuData", "subItem", "tabIndex", "subIndex"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (state.listData.length>0)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.listData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["folder_item_box", {borderBottom:state.taggerIndex!==index}]),
                  onClick: ($event: any) => (onTagger(item,index))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.Name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", null, _toDisplayString(item.ContentList.length) + "个套件", 1),
                    _hoisted_13,
                    _createElementVNode("span", null, [
                      _createVNode(_component_el_icon, { size: 20 }, {
                        default: _withCtx(() => [
                          (state.taggerIndex===index)
                            ? (_openBlock(), _createBlock(_component_ArrowUp, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_ArrowDown, { key: 1 }))
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ], 10, _hoisted_8),
                _withDirectives(_createElementVNode("div", {
                  class: "folder_item_collapse",
                  ref_for: true,
                  ref_key: "licol",
                  ref: licol
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ContentList, (ele, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "folder_name",
                      onClick: ($event: any) => (onRouterDetail(ele.Id))
                    }, _toDisplayString(ele.Name), 9, _hoisted_14))
                  }), 256))
                ], 512), [
                  [_vShow, state.taggerIndex===index]
                ])
              ]))
            }), 256))
          ])), [
            [_directive_loading, state.loading]
          ])
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "暂无数据"
          }))
    ])
  ]))
}
}

})